import { Group, Burger, Text, ActionIcon, useMantineColorScheme, rem, Menu, Avatar, Badge } from '@mantine/core'
import { IconSun, IconMoon, IconBell, IconUser, IconLogout, IconSettings, IconShield } from '@tabler/icons-react'
import { useNavigate } from 'react-router-dom'
import { useAuthStore } from '@/store/auth'

interface HeaderProps {
  opened: boolean
  toggle: () => void
}

export function Header({ opened, toggle }: HeaderProps) {
  const navigate = useNavigate()
  const { colorScheme, toggleColorScheme } = useMantineColorScheme()
  const dark = colorScheme === 'dark'
  const { user, logout } = useAuthStore()

  const handleLogout = async () => {
    await logout()
    navigate('/login')
  }

  return (
    <Group h="100%" px="md" justify="space-between">
      <Group>
        <Burger opened={opened} onClick={toggle} hiddenFrom="sm" size="sm" />
        <Text size="xl" fw={700} gradient={{ from: 'blue', to: 'cyan', deg: 45 }} variant="gradient">
          RustSwarm
        </Text>
      </Group>

      <Group gap="xs">
        <ActionIcon
          variant="subtle"
          color="gray"
          size="lg"
          radius="md"
          onClick={() => toggleColorScheme()}
          title="Toggle color scheme"
        >
          {dark ? (
            <IconSun style={{ width: rem(20), height: rem(20) }} stroke={1.5} />
          ) : (
            <IconMoon style={{ width: rem(20), height: rem(20) }} stroke={1.5} />
          )}
        </ActionIcon>

        <ActionIcon variant="subtle" color="gray" size="lg" radius="md" title="Notifications">
          <IconBell style={{ width: rem(20), height: rem(20) }} stroke={1.5} />
        </ActionIcon>

        <Menu shadow="md" width={200} position="bottom-end">
          <Menu.Target>
            <ActionIcon variant="subtle" color="gray" size="lg" radius="md" title="Profile">
              <Avatar size="sm" radius="xl" color="blue">
                <IconUser style={{ width: rem(16), height: rem(16) }} />
              </Avatar>
            </ActionIcon>
          </Menu.Target>

          <Menu.Dropdown>
            <Menu.Label>
              <Group gap="xs">
                <Text size="sm" fw={500}>
                  {user?.username || 'User'}
                </Text>
                {user?.is_super_user && (
                  <Badge size="xs" color="red" variant="light">
                    Admin
                  </Badge>
                )}
              </Group>
            </Menu.Label>

            <Menu.Divider />

            <Menu.Item
              leftSection={<IconUser style={{ width: rem(14), height: rem(14) }} />}
              onClick={() => navigate('/settings')}
            >
              Profile
            </Menu.Item>

            {user?.is_super_user && (
              <Menu.Item
                leftSection={<IconShield style={{ width: rem(14), height: rem(14) }} />}
                onClick={() => navigate('/tenants')}
              >
                Tenants
              </Menu.Item>
            )}

            <Menu.Item
              leftSection={<IconSettings style={{ width: rem(14), height: rem(14) }} />}
              onClick={() => navigate('/settings')}
            >
              Settings
            </Menu.Item>

            <Menu.Divider />

            <Menu.Item
              color="red"
              leftSection={<IconLogout style={{ width: rem(14), height: rem(14) }} />}
              onClick={handleLogout}
            >
              Logout
            </Menu.Item>
          </Menu.Dropdown>
        </Menu>
      </Group>
    </Group>
  )
}